import { motion } from "framer-motion";
import type { ChatPanelQuickActionsProps } from "./types";
import { springs } from "../motion";
import { Button } from "../primitives";

export function ChatPanelQuickActions({ actions }: ChatPanelQuickActionsProps) {
  return (
    <div className="flex flex-wrap gap-2 px-4 py-2">
      {actions.map((action, index) => (
        <motion.div
          key={action.label}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ ...springs.snappy, delay: index * 0.05 }}
        >
          <Button
            variant="ghost"
            size="sm"
            onClick={action.onClick}
            className="rounded-full border border-border"
            aria-label={`Quick action: ${action.label}`}
          >
            {action.label}
          </Button>
        </motion.div>
      ))}
    </div>
  );
}
